export const PAGE_PATH = {
  AGENT_PLAYER: '/p',
  AGENTS: '/a',
  CALLBACK: '/callback',
  DASHBOARD: '/apps',
  HOME: '/',
  PLANS: '/pricing',
} as const
